export enum ProductType {
  PRODUCT = "PRODUCT",
  SERVICE = "SERVICE",
  GIFT_CARD = "GIFT_CARD",
  TEXT = "TEXT",
  SERVICE_ORDER_DEPOSIT = "SERVICE_ORDER_DEPOSIT",
}
